/* ===== v30: Order on WhatsApp (works on product pages and inside the quick-view popup) ===== */
(function () {
  if (window.__tvgWaOrder) return;
  window.__tvgWaOrder = true;

  var KEY = 'tvg_wa_details';
  var WA = '<path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91A9.85 9.85 0 0 0 12.04 2Z"/>';
  var STORES = ['Wapda Town (Head Office), Gujranwala', 'Main GT Road, Rahwali, Gujranwala', 'DHA Phase 1, Lahore', 'C Mall, Sialkot', 'University Road, Sargodha'];
  var CITIES = ['Lahore', 'Karachi', 'Islamabad', 'Rawalpindi', 'Gujranwala', 'Faisalabad', 'Sialkot', 'Multan', 'Sargodha', 'Peshawar', 'Gujrat', 'Hyderabad', 'Bahawalpur', 'Sahiwal', 'Sheikhupura'];
  var sheet, form, ctx = null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) { return 'Rs ' + Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function $(s, r) { return (r || document).querySelector(s); }

  function build() {
    sheet = document.createElement('dialog');
    sheet.className = 'wa-sheet';
    sheet.setAttribute('aria-labelledby', 'wa-sheet-title');
    sheet.innerHTML =
      '<form class="wa-sheet__box" method="dialog" novalidate>' +
        '<div class="wa-sheet__head">' +
          '<span class="wa-sheet__badge" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor">' + WA + '</svg></span>' +
          '<div><h2 id="wa-sheet-title" class="wa-sheet__title">Order on WhatsApp</h2><p class="wa-sheet__sub">Fill in once — we confirm on WhatsApp within minutes.</p></div>' +
          '<button type="button" class="wa-sheet__x" data-wa-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        '</div>' +
        '<div class="wa-sum">' +
          '<img class="wa-sum__img" alt="" width="64" height="64" decoding="async" data-wa-img>' +
          '<div class="wa-sum__info"><p class="wa-sum__title" data-wa-title></p><p class="wa-sum__var" data-wa-variant></p><p class="wa-sum__price" data-wa-line></p></div>' +
          '<div class="wa-qty" role="group" aria-label="Quantity"><button type="button" data-wa-qty="-1" aria-label="Decrease quantity">−</button><output data-wa-qtyout>1</output><button type="button" data-wa-qty="1" aria-label="Increase quantity">+</button></div>' +
        '</div>' +
        '<fieldset class="wa-mode"><legend class="wa-vh">Delivery or pickup</legend>' +
          '<label class="wa-mode__opt"><input type="radio" name="wa_mode" value="delivery" checked> <span>Home delivery <small>COD nationwide</small></span></label>' +
          '<label class="wa-mode__opt"><input type="radio" name="wa_mode" value="pickup"> <span>Store pickup <small>Free · ready in ~1 hr</small></span></label>' +
        '</fieldset>' +
        '<div class="wa-grid">' +
          '<label class="wa-f"><span>Full name *</span><input name="wa_name" type="text" autocomplete="name" placeholder="e.g. Ali Khan" maxlength="60"></label>' +
          '<label class="wa-f"><span>Phone / WhatsApp *</span><input name="wa_phone" type="tel" inputmode="tel" autocomplete="tel" placeholder="03XX XXXXXXX" maxlength="16"></label>' +
          '<label class="wa-f" data-wa-for="delivery"><span>City *</span><input name="wa_city" type="text" autocomplete="address-level2" placeholder="e.g. Lahore" list="wa-cities" maxlength="40">' +
            '<datalist id="wa-cities">' + CITIES.map(function (c) { return '<option value="' + c + '">'; }).join('') + '</datalist></label>' +
          '<label class="wa-f wa-f--full" data-wa-for="delivery"><span>Full address *</span><textarea name="wa_address" rows="2" autocomplete="street-address" placeholder="House #, street, area / landmark" maxlength="220"></textarea></label>' +
          '<label class="wa-f wa-f--full" data-wa-for="pickup" hidden><span>Pickup store *</span><select name="wa_store">' + STORES.map(function (s) { return '<option value="' + s + '">' + s + '</option>'; }).join('') + '</select></label>' +
          '<label class="wa-f wa-f--full"><span>Note <em>(optional)</em></span><input name="wa_note" type="text" placeholder="Flavour swap, delivery time, etc." maxlength="140"></label>' +
        '</div>' +
        '<p class="wa-err" role="alert" data-wa-err hidden></p>' +
        '<div class="wa-foot"><div class="wa-total"><span>Total</span><strong data-wa-total></strong><small data-wa-ship></small></div>' +
          '<button type="submit" class="wa-send"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' + WA + '</svg> Send order on WhatsApp</button></div>' +
        '<p class="wa-fine">Details stay on this device only. Delivery charges confirmed on WhatsApp.</p>' +
      '</form>';
    document.body.appendChild(sheet);
    form = $('form', sheet);

    sheet.addEventListener('close', function () { document.documentElement.classList.remove('wa-lock'); });
    sheet.addEventListener('cancel', function () { document.documentElement.classList.remove('wa-lock'); });
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet || e.target.closest('[data-wa-close]')) { close(); return; }
      var b = e.target.closest('[data-wa-qty]');
      if (b) { ctx.qty = Math.min(50, Math.max(1, ctx.qty + parseInt(b.getAttribute('data-wa-qty'), 10))); paint(); }
    });
    form.addEventListener('change', function (e) { if (e.target.name === 'wa_mode') setMode(); });
    form.addEventListener('submit', send);
  }

  function variantsOf(root) {
    try { return JSON.parse((($('script[data-variants]', root) || {}).textContent) || '[]'); } catch (e) { return []; }
  }
  function currentVariant(root, list) {
    var input = $('[data-variant-input]', root);
    var id = input ? parseInt(input.value, 10) : 0;
    if (!id && list.length === 1) id = list[0].id;
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return null;
  }
  function formError(root, msg) {
    var pe = $('[data-form-error]', root);
    if (!pe) return;
    pe.textContent = msg; pe.hidden = false;
    pe.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function paint() {
    var v = ctx.v, line = v.price * ctx.qty, pickup = form.wa_mode.value === 'pickup';
    $('[data-wa-qtyout]', sheet).textContent = ctx.qty;
    $('[data-wa-title]', sheet).textContent = ctx.title;
    $('[data-wa-variant]', sheet).textContent = (v.title && v.title !== 'Default Title') ? v.title : '';
    $('[data-wa-line]', sheet).textContent = money(v.price) + (ctx.qty > 1 ? ' × ' + ctx.qty : '');
    $('[data-wa-total]', sheet).textContent = money(line);
    $('[data-wa-ship]', sheet).textContent = pickup ? 'Free pickup' : (ctx.free && line >= ctx.free ? 'Free delivery' : '+ delivery');
    $('[data-wa-img]', sheet).src = v.img || ctx.img;
  }
  function setMode() {
    var pickup = form.wa_mode.value === 'pickup';
    sheet.querySelectorAll('[data-wa-for]').forEach(function (el) { el.hidden = el.getAttribute('data-wa-for') !== (pickup ? 'pickup' : 'delivery'); });
    paint();
  }
  function load() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || '{}');
      ['wa_name', 'wa_phone', 'wa_city', 'wa_address'].forEach(function (k) { if (d[k] && !form[k].value) form[k].value = d[k]; });
      if (d.wa_store) form.wa_store.value = d.wa_store;
      if (d.wa_mode) { var r = form.querySelector('input[name="wa_mode"][value="' + d.wa_mode + '"]'); if (r) r.checked = true; }
    } catch (e) {}
  }
  function save() {
    try {
      localStorage.setItem(KEY, JSON.stringify({ wa_name: form.wa_name.value.trim(), wa_phone: form.wa_phone.value.trim(), wa_city: form.wa_city.value.trim(), wa_address: form.wa_address.value.trim(), wa_store: form.wa_store.value, wa_mode: form.wa_mode.value }));
    } catch (e) {}
  }
  function showErr(msg, field) {
    var el = $('[data-wa-err]', sheet);
    el.textContent = msg; el.hidden = !msg;
    sheet.querySelectorAll('.wa-f.is-bad').forEach(function (f) { f.classList.remove('is-bad'); });
    if (field) { var f = field.closest('.wa-f'); if (f) f.classList.add('is-bad'); field.focus(); }
  }
  function open(btn) {
    var root = btn.closest('[data-product-root]') || document;
    var list = variantsOf(root);
    var v = currentVariant(root, list);
    if (!v) return formError(root, 'Please choose your options first, then tap Order on WhatsApp.');
    if (v.available === false) return formError(root, 'This option is sold out — please pick another.');
    var errBox = $('[data-form-error]', root); if (errBox) errBox.hidden = true;
    if (!sheet) build();
    var q = $('[data-qty-input]', root);
    ctx = {
      v: v,
      qty: Math.max(1, parseInt(q && q.value, 10) || 1),
      num: btn.getAttribute('data-wa-num'),
      title: btn.getAttribute('data-wa-title') || '',
      url: btn.getAttribute('data-wa-url') || location.href,
      img: btn.getAttribute('data-wa-img') || '',
      free: parseInt(btn.getAttribute('data-wa-free'), 10) || 0
    };
    load(); setMode(); showErr('');
    if (typeof sheet.showModal === 'function') { if (!sheet.open) sheet.showModal(); } else sheet.setAttribute('open', '');
    document.documentElement.classList.add('wa-lock');
    if (!window.matchMedia('(pointer: coarse)').matches) {
      setTimeout(function () { var first = [form.wa_name, form.wa_phone].filter(function (f) { return !f.value; })[0]; if (first) first.focus(); }, 60);
    }
  }
  function close() {
    if (typeof sheet.close === 'function' && sheet.open) sheet.close(); else sheet.removeAttribute('open');
    document.documentElement.classList.remove('wa-lock');
  }
  function send(e) {
    e.preventDefault();
    var pickup = form.wa_mode.value === 'pickup';
    var name = form.wa_name.value.trim();
    var digits = form.wa_phone.value.replace(/\D/g, '');
    if (digits.indexOf('92') === 0 && digits.length === 12) digits = '0' + digits.slice(2);
    if (digits.length === 10 && digits.charAt(0) === '3') digits = '0' + digits;
    var city = form.wa_city.value.trim();
    var addr = form.wa_address.value.trim();
    if (name.length < 2) return showErr('Please enter your name.', form.wa_name);
    if (!/^03\d{9}$/.test(digits)) return showErr('Please enter a valid mobile number, e.g. 0300 1234567.', form.wa_phone);
    if (!pickup && city.length < 2) return showErr('Please enter your city.', form.wa_city);
    if (!pickup && addr.length < 6) return showErr('Please enter your full delivery address.', form.wa_address);
    showErr(''); save();

    var v = ctx.v;
    var link = ctx.url.split('?')[0] + '?variant=' + v.id;
    var L = ['*New Order — The Vape Guys*', '', '🛒 *' + ctx.title + '*'];
    if (v.title && v.title !== 'Default Title') L.push('• Option: ' + v.title);
    L.push('• Qty: ' + ctx.qty + '  ×  ' + money(v.price));
    L.push('• Total: *' + money(v.price * ctx.qty) + '*');
    L.push('• Link: ' + link, '', '👤 Name: ' + name, '📱 Phone: ' + digits.slice(0, 4) + ' ' + digits.slice(4));
    if (pickup) L.push('🏬 Store pickup: ' + form.wa_store.value);
    else L.push('🚚 Home delivery (COD)', '🏙️ City: ' + city, '📍 Address: ' + addr);
    var note = form.wa_note.value.trim();
    if (note) L.push('📝 Note: ' + note);
    L.push('', 'Please confirm my order. Thank you!');

    var url = 'https://wa.me/' + ctx.num + '?text=' + encodeURIComponent(L.join('\n'));
    var w = null;
    try { w = window.open(url, '_blank'); } catch (err) {}
    if (w) { try { w.opener = null; } catch (err) {} } else { window.location.href = url; }
    close();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wa-order]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn);
  });
})();
